(function() {
    'use strict';

    angular
        .module('app.bloqueos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/bloqueo-admin',
                config: {
                    templateUrl: 'app/bloqueos/bloqueosAdmin.html',
                    controller: 'BloqueosAdmin',
                    controllerAs: 'vm',
                    title: 'Bloqueos'
                }
            },
            {
                url: '/bloqueo-usuario',
                config: {
                    templateUrl: 'app/bloqueos/bloqueosUsuario.html',
                    controller: 'BloqueosUsuario',
                    controllerAs: 'vm',
                    title: 'Bloqueos'
                }
            }
        ];
    }
})();
